<template>
  <div 
    class="  px-10 mt-12">
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span 
        class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          icon
          color="white"
          class="body-1 font-weight-bold text-capitalize"
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="dialog.imei"
      @keydown.esc="dialog.imei = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
        class="">
        <v-card-title 
          class="d-flex align-center  pb-4 text-right popup-header fs-20 font-weight-bold">
          
          Reset Imei

          <v-spacer/>

          <!-- <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#4828a1">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.imei = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon> -->

          <v-icon 
            @click="dialog.imei = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="18"
            color="#000000">
            mdi-close
          </v-icon>
        </v-card-title>
        
        <v-divider 
          class="mb-2"
          style="border-top: 2px dashed #e0e0e0;"/>

        <v-card-text 
          class="body-1 font-weight-light text-first line-text-second my-0  py-3">
          
          Apakah anda yakin ingin mereset Imei dari pegawai ini?

          <div v-if="message.error.length > 0"
            class="text-center mt-0">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>


        <v-divider 
          class="mt-2"
          style="border-top: 2px dashed #e0e0e0;"/>

        <v-card-actions
          class="pt-4 pb-4">
          <v-spacer/>

          <v-btn
            @click="save()"
            :loading="process.delete"
            :disabled="process.delete"
            elevation="0"
            width="120"
            color="#6948c6"
            style="border-radius: 8px;"
            class="fs-14 white--text font-weight-bold text-capitalize px-3">
            Ya, reset
          </v-btn>

          <v-btn
            width="120"
            @click="dialog.imei = false; dialog.fullscreen = false;"
            :disabled="process.delete"
            outlined
            style="border-radius: 8px;"
            class="fs-14 font-weight-bold text-capitalize red--text">
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-layout wrap>
        <v-flex>
          <section>
            <div class="color-dark-blue fs-22 font-weight-bold">
              Detail Staff
            </div>
  
            <v-row
              class="mt-2">
              <v-col 
                cols="12"
                class="py-0">
                <v-card 
                  flat
                  min-height="calc(100vh - 245px)"
                  style="border-radius: 25px; border: 1px solid #E7E7E7;">
                  <v-card-text
                    v-if="process.form" 
                    class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-2 title">
                        Mohon Tunggu...
                      </div>
                      <v-progress-circular
                        indeterminate
                      ></v-progress-circular>
                    </div>
                  </v-card-text>

                  <v-card-text v-if="!process.form && Object.keys(detail).length > 0">
                    <v-row>
                      <v-col cols="12" md="6">
                        <table>
                          <tr>
                            <td>
                              Nama
                            </td>
                            <td style="width: 60px" class="text-right py-1 pr-1">
                              : 
                            </td>
                            <td class="fs-16 label-input">
                              {{ detail.name }}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              NIK
                            </td>
                            <td style="width: 60px" class="text-right py-1 pr-1">
                              : 
                            </td>
                            <td class="fs-16 label-input">
                              {{ detail.nik }}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Email
                            </td>
                            <td style="width: 60px" class="text-right py-1 pr-1">
                              : 
                            </td>
                            <td class="fs-16 label-input">
                              {{ detail.email === '' ? '-' : detail.email }}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Mobilephone
                            </td>
                            <td style="width: 60px" class="text-right py-1 pr-1">
                              : 
                            </td>
                            <td class="fs-16 label-input">
                              <span>
                                {{ detail.mobilephone === '' ? '-' : detail.mobilephone }}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Jenis Kelamin
                            </td>
                            <td style="width: 60px" class="text-right py-1 pr-1">
                              : 
                            </td>
                            <td class="fs-16 label-input">
                              {{ detail.gender === '' ? '-' : detail.gender }}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Alamat
                            </td>
                            <td style="width: 60px" class="text-right py-1 pr-1">
                              : 
                            </td>
                            <td class="fs-16 label-input">
                              {{ detail.address !== '' ? detail.address : '-'}}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              No. Rekening
                            </td>
                            <td style="width: 60px" class="text-right py-1 pr-1">
                              :
                            </td>
                            <td class="fs-16 label-input">
                              {{ detail.bank_name }} - {{ detail.rek_number === '' ? '-' : detail.rek_number }}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Nama Rekening
                            </td>
                            <td style="width: 60px" class="text-right py-1 pr-1">
                              :
                            </td>
                            <td class="fs-16 label-input">
                              {{ detail.rek_name === '' ? '-' : detail.rek_name }}
                            </td>
                          </tr>
                          <tr v-if="detail.category_user_title === 'Driver'">
                            <td>
                              Imei
                            </td>
                            <td style="width: 60px" class="text-right py-1 pr-1">
                              :
                            </td>
                            <td class="fs-16 label-input">
                              {{ detail.imei === '' ? '-' : detail.imei }}
                            </td>
                          </tr>

                        </table>
                        <v-btn
                          class="mt-4 text-capitalize"
                          color="primary"
                          elevation="0"
                          v-if="detail.category_user_title === 'Driver'"
                          style="border-radius: 6px;"
                          @click="dialog.imei = true; form.imei = ''; message.error = '';">
                          Reset Imei
                        </v-btn>
                      </v-col>
                      <v-col cols="12" md="6">
                        <table>
                          <tr>
                            <td>
                              Kateogri Pegawai
                            </td>
                            <td style="width: 60px" class="text-right py-1 pr-1">
                              : 
                            </td>
                            <td class="fs-16 label-input">
                              {{ detail.category_user_title }}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Cabang
                            </td>
                            <td style="width: 60px" class="text-right py-1 pr-1">
                              : 
                            </td>
                            <td class="fs-16 label-input">
                              {{ detail.branch_name }}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Kode
                            </td>
                            <td style="width: 60px" class="text-right py-1 pr-1">
                              : 
                            </td>
                            <td class="fs-16 label-input">
                              <span>
                                {{ detail.code === '' ? '-' : detail.code }}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Deskripsi
                            </td>
                            <td style="width: 60px" class="text-right py-1 pr-1">
                              : 
                            </td>
                            <td class="fs-16 label-input">
                              {{ detail.desc === '' ? '-' : detail.desc }}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Tangga Bergabung
                            </td>
                            <td style="width: 60px" class="text-right py-1 pr-1">
                              : 
                            </td>
                            <td class="fs-16 label-input">
                              {{ detail.join_date | date('DD MMMM YYYY') }}
                            </td>
                          </tr>

                        </table>
                        <div>
                          <div 
                            class="fs-14">
                            
                            Foto Pegawai
                          </div>
                          <div class="fs-16 label-input">
                            <div style="border: 1px solid #DFEAF2; border-radius: 15px; width: 200px;" class="mt-2">
                              <v-img
                                :src="detail.image_url"
                                contain
                                width="200"
                                height="200"
                                >
                              </v-img>
                            </div>
                          </div>
                        </div>
            
                        <div>
                          <div 
                            class="fs-14">
                            
                            Tanda Tangan
                          </div>
                          <div class="fs-16 label-input">
                            <div style="border: 1px solid #DFEAF2; border-radius: 15px;" class="mt-2">
                              <v-img
                                :src="detail.ttd"
                                contain
                                width="250"
                                height="150"
                                >
                              </v-img>
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
  
                    <div v-if="message.error.length > 0"
                      class="text-center my-4 d-flex align-center">
                      <div
                        class="error--text">
                        <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                        
                        <span
                          class="ml-1">
                          {{ message.error }}
                        </span>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              justify="end"
              class="pa-4 pr-1">
              <v-col 
                cols="12"
                md="12"
                class="d-flex align-center justify-end py-0">
                
                <v-btn
                  to="/user/staff"
                  :disabled="process.form"
                  color="red"
                  elevation="0"
                  width="140"
                  height="45"
                  class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                  style="font-weight: 600;">
                
                    Kembali
                </v-btn>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          menu: false,
          modal: false,
          menu2: false,
          
          zoomed: false,
          zoomedTtd: false,
          imageAspectRatio: 1,
          imageAspectRatioTtd: 1,

          dialog: {
            snackbar: false,
            imei: false,
            fullscreen: false
          },

          detail: {},
  
          form: {
            id: '',
            par_id: '0',
            category_user_id: '',
            branch_id: '',
            code: '',
            name: '',
            mobilephone: '',
            address: '',
            gender: '',
            email: '',
            nik: '',
            rek_number: '',
            rek_name: '',
            join_date: '',
            bank_name: '',
            image_url: '',
            desc: '',
            ttd: '',
            imei: ''
          },
          category: [],
          branch: [],
  
          mobilephone: {
            name: '',
            id: ''
          },
  
          upload: {
            ttd: null,
            image_url: null
          },
  
          process: {
            form: false,
  
            ttd: false,
  
            image_url: false,
            delete: false
          },
          
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
      },
      watch: {
        'upload.ttd': {
          handler: function () {
            if (this.upload.ttd) {
              this.process.ttd = this.upload.ttd.process
  
              if (!this.process.ttd) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.ttd = this.upload.ttd.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        },
  
        'upload.image_url': {
          handler: function () {
            if (this.upload.image_url) {
              this.process.image_url = this.upload.image_url.process
  
              if (!this.process.image_url) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.image_url = this.upload.image_url.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        }
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      mounted () {
        this.fetchDetail()
      },
      methods: {
        async fetchDetail () {
          this.process.form = true
          let params = {
            id: this.$route.params.id
          }
  
          await get('admin/user/detail', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.detail = res.results.data
            }
            this.process.form = false
          })
        },
        onImageLoad(e) {
          const img = e.target
          this.imageAspectRatio = img.naturalWidth / img.naturalHeight
        },
        onImageLoadAkta(e) {
          const img = e.target
          this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
        },
        async save () {
          this.message.error = ''

          const isValid = true

          if (isValid) {
            this.process.delete = true

            let url = 'admin/user/reset_imei'

            // SAVE TO REST API
            await post(url, {
              data: {
                id: this.detail.id
              }
            })
            .then(response => {
              let res = response.data
              
              this.process.delete = false

              if (res.status === 200) {
                this.dialog.imei = false
                
                this.fetchDetail()
                this.dialog.snackbar = true
                this.message.success = res.message

                this.dialog.fullscreen = false
                
              } else {
                this.message.error = res.message
              }
            })

          } else {
            this.error = 'Imei tidak boleh kosong'
          }
        },
      }
    }
  </script>